import { render, staticRenderFns } from "./AdmissionDeleteModal.vue?vue&type=template&id=71a54e9d&scoped=true&"
import script from "./AdmissionDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AdmissionDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a54e9d",
  null
  
)

export default component.exports